import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Tempotravellerrentalforcorporatepicnic() {



const cardData =
{
  keyword: 'Tempo Traveller Rental for Corporate Picnic',
  heading: 'Sanavi Travels: Tempo Traveller Rental for Corporate Picnic',
  headingDescription: 'Sanavi Travels provides professionally managed Tempo Traveller rental services for corporate picnics, designed to ensure smooth group travel, employee comfort, punctual scheduling, and stress-free coordination for companies planning outings, team bonding activities, and corporate leisure trips.',

  top: 'Top Experiences & Benefits of Corporate Picnic Travel with Tempo Traveller',

  topPlaces: [
    {
      title: 'Corporate Picnic Destinations Near Pune',
      description: 'Corporate picnics are often planned at resorts, hill stations, lakesides, amusement parks, and nature spots near Pune. Renting a Tempo Traveller ensures all employees travel together in a single vehicle, maintaining unity, discipline, and easy coordination. The spacious interiors allow teams to relax, chat, and bond even before reaching the destination, making the journey itself part of the corporate outing experience. HR teams appreciate the convenience of managing attendance and schedules without worrying about individual vehicles or delays.'
    },
    {
      title: 'Team Bonding During Travel',
      description: 'Travel time during a corporate picnic plays a key role in informal bonding. A Tempo Traveller offers ample seating, open layout, and comfortable space where colleagues can interact freely, play music, discuss plans, and build rapport. This shared journey strengthens team relationships and sets a positive tone for the picnic activities ahead.'
    },
    {
      title: 'Safe & Organized Employee Transport',
      description: 'Safety is a priority during corporate outings. Tempo Traveller rentals provide licensed drivers, well-maintained vehicles, and structured seating, ensuring employees reach picnic locations safely and on time. Group travel also reduces the risks associated with employees driving individually or using multiple vehicles.'
    },
    {
      title: 'Flexible Itineraries & Multiple Stops',
      description: 'Corporate picnic plans often include breakfast stops, sightseeing breaks, or activity locations en route. Tempo Traveller rentals allow flexible routing and scheduled stops without logistical complications. This flexibility is especially valuable for full-day or multi-location corporate outings.'
    },
    {
      title: 'Comfort for Long-Distance Travel',
      description: 'Many corporate picnic destinations involve longer drives. Tempo Travellers are designed for comfort, with push-back seats, ample legroom, and good suspension, helping employees arrive refreshed and energetic rather than fatigued.'
    },
    {
      title: 'Ideal for Mixed Age Groups',
      description: 'Corporate teams often include employees of different age groups. Tempo Travellers offer comfortable seating and easy entry, making them suitable for everyone, including senior staff members.'
    },
    {
      title: 'Convenient Luggage & Equipment Transport',
      description: 'Corporate picnics may involve sports equipment, sound systems, food supplies, or activity kits. Tempo Travellers provide sufficient luggage space, keeping the passenger area uncluttered and organized.'
    },
    {
      title: 'Cost-Effective Group Travel',
      description: 'Using one Tempo Traveller instead of multiple cars or cabs significantly reduces travel costs. It also simplifies expense management for companies by consolidating transport into a single booking.'
    },
    {
      title: 'Professional Image for Corporates',
      description: 'Arriving together in a well-maintained Tempo Traveller reflects professionalism and organized planning, especially during outings involving clients, partners, or inter-office teams.'
    },
    {
      title: 'Eco-Friendly Corporate Travel',
      description: 'Group travel in a single vehicle reduces fuel consumption, traffic congestion, and carbon footprint, supporting corporate sustainability initiatives.'
    }
  ],

  services: [
    {
      name: 'Tempo Traveller Rental for Corporate Picnic',
      description: 'Sanavi Travels offers dedicated Tempo Traveller rental services for corporate picnics, ensuring reliable, comfortable, and organized group transportation. Our Tempo Travellers are ideal for company outings, employee engagement programs, and team-building events. With spacious seating, smooth ride quality, and experienced drivers, this service helps corporates focus on enjoyment and bonding rather than travel logistics.'
    },
    {
      name: 'AC Tempo Traveller Corporate Picnic',
      description: 'AC Tempo Travellers provide a cool and comfortable environment, especially during summer outings. Employees arrive relaxed and ready to participate in activities.'
    },
    {
      name: 'Non AC Tempo Traveller Corporate Picnic',
      description: 'Non-AC options offer economical solutions for large teams while maintaining seating comfort and safety.'
    },
    {
      name: '12 Seater Tempo Traveller Corporate Picnic',
      description: '12 seater Tempo Travellers are suitable for small corporate teams, management groups, or startup outings.'
    },
    {
      name: '16 Seater Tempo Traveller Corporate Picnic',
      description: '16 seater Tempo Travellers balance comfort and capacity, making them ideal for mid-sized office teams.'
    },
    {
      name: '20 Seater Tempo Traveller Corporate Picnic',
      description: '20 seater Tempo Travellers are perfect for larger departments or full team outings, ensuring everyone travels together.'
    },
    {
      name: 'Luxury Tempo Traveller Corporate Picnic',
      description: 'Luxury Tempo Travellers feature premium interiors, enhanced suspension, and superior comfort, suitable for senior management or VIP corporate groups.'
    },
    {
      name: 'Tempo Traveller for Family Corporate Picnic',
      description: 'For corporate picnics that include employee families, Tempo Travellers offer safe and comfortable travel for adults and children alike.'
    },
    {
      name: 'Tempo Traveller for Corporate Team Outing',
      description: 'Team outings become more enjoyable and organized when everyone travels together, encouraging interaction and collaboration.'
    },
    {
      name: 'Tempo Traveller for Group Corporate Picnic',
      description: 'Group-focused services ensure smooth coordination, punctual departures, and unified travel experience.'
    },
    {
      name: 'Affordable Tempo Traveller Corporate Picnic',
      description: 'Sanavi Travels offers competitive and transparent pricing, helping companies manage budgets effectively.'
    },
    {
      name: 'Best Tempo Traveller Service Corporate Picnic',
      description: 'Our reputation is built on reliability, punctuality, clean vehicles, and professional drivers.'
    },
    {
      name: 'Tempo Traveller with Driver Corporate Picnic',
      description: 'All bookings include experienced drivers who manage routes, timings, and safe driving throughout the trip.'
    },
    {
      name: 'Tempo Traveller for Wedding Corporate Picnic',
      description: 'Some corporate events combine celebrations and outings. Tempo Travellers handle guest and team transport efficiently.'
    },
    {
      name: 'Mini Bus on Rent Corporate Picnic',
      description: 'For larger corporate groups, mini bus options are available as an alternative to Tempo Travellers.'
    }
  ],

  tableData: [
    ['AC Tempo Traveller', 'Non AC Tempo Traveller'],
    ['12 Seater', '16 Seater'],
    ['20 Seater', 'Luxury Variant'],
    ['Corporate Picnic', 'Team Outing'],
    ['Affordable Plans', 'Premium Comfort']
  ],

  whychoose: [
    {
      WhyChooseheading: 'Corporate-Focused Travel Solutions',
      WhyChoosedescription: 'Services designed specifically to meet corporate outing and picnic requirements.'
    },
    {
      WhyChooseheading: 'Comfortable Group Vehicles',
      WhyChoosedescription: 'Spacious seating and smooth rides ensure employee comfort throughout the journey.'
    },
    {
      WhyChooseheading: 'Experienced Professional Drivers',
      WhyChoosedescription: 'Drivers trained for punctual, safe, and disciplined corporate travel.'
    },
    {
      WhyChooseheading: 'Transparent & Budget-Friendly Pricing',
      WhyChoosedescription: 'Clear pricing without hidden charges simplifies corporate approvals.'
    },
    {
      WhyChooseheading: 'Reliable & Well-Maintained Fleet',
      WhyChoosedescription: 'Regular maintenance ensures dependable performance.'
    },
    {
      WhyChooseheading: 'Flexible Scheduling & Routes',
      WhyChoosedescription: 'Custom pickup points and itineraries based on corporate plans.'
    },
    {
      WhyChooseheading: 'Ideal for Team Bonding',
      WhyChoosedescription: 'Group travel enhances interaction and team spirit.'
    },
    {
      WhyChooseheading: '24/7 Customer Support',
      WhyChoosedescription: 'Dedicated support before and during the corporate outing.'
    }
  ]
};

const faqData = [
  {
    question: 'Do you provide Tempo Traveller rental for corporate picnics?',
    answer: 'Yes, Sanavi Travels offers dedicated Tempo Traveller rental services specifically for corporate picnics and team outings.'
  },
  {
    question: 'Are AC Tempo Travellers available?',
    answer: 'Yes, both AC and Non-AC Tempo Traveller options are available.'
  },
  {
    question: 'Can we choose seating capacity?',
    answer: 'Yes, 12, 16, and 20 seater Tempo Travellers are available based on group size.'
  },
  {
    question: 'Are drivers experienced with corporate travel?',
    answer: 'Yes, our drivers are trained to handle corporate schedules and professional travel needs.'
  },
  {
    question: 'Is this service suitable for employee family picnics?',
    answer: 'Yes, Tempo Travellers are suitable for mixed groups including employees and their families.'
  },
  {
    question: 'Can pickup points be customized?',
    answer: 'Yes, pickup and drop locations can be customized.'
  },
  {
    question: 'Is advance booking required?',
    answer: 'Advance booking is recommended, especially during peak seasons.'
  },
  {
    question: 'Are vehicles sanitized?',
    answer: 'Yes, all vehicles are cleaned and sanitized before each trip.'
  },
  {
    question: 'Is pricing transparent?',
    answer: 'Yes, we follow a clear and transparent pricing policy.'
  },
  {
    question: 'Is customer support available?',
    answer: 'Yes, 24/7 customer support is provided.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Mehta',
    feedback: 'Our company booked a Tempo Traveller from Sanavi Travels for a corporate picnic. The vehicle was clean, spacious, and very comfortable. The driver was punctual and professional, and the entire trip was perfectly coordinated. It made our team outing smooth and enjoyable.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Kavita Nair',
    feedback: 'Sanavi Travels managed our corporate picnic transport excellently. The Tempo Traveller was ideal for our team size, and traveling together really improved bonding. Highly recommended for corporate outings.',
    rating: 5
  }
];





































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];







const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Tempo Traveller Rental for Corporate Picnic - Sanavi Travels",
  "description": "Sanavi Travels offers Tempo Traveller rentals for corporate picnics and team outings, including AC and Non-AC options in 12-seater, 16-seater, and 20-seater configurations. Luxury Tempo Travellers and mini bus options are ideal for corporate team outings, group travel, weddings, and corporate events with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};









  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | Tempo Traveller Rental for Corporate Picnic | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book Tempo Travellers for corporate picnics with Sanavi Travels. AC & Non-AC 12, 16, and 20-seater luxury Tempo Travellers and mini buses for corporate team outings, group travel, weddings, and corporate events with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/306.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Tempotravellerrentalforcorporatepicnic;